export default "__VITE_ASSET__DmIr7ivf__"